const Styles = () => ({
  root: {
    fontSize: '1em',
    '& h2': {
      fontSize: '1.5em'
    }
  },
  textField: {
    '& > *': {
      margin: '15px 0px'
    },
  },
});

export default Styles;
